import { useContext } from "react";
import { spacing } from "../../stitches.config";
import { FlexColumn } from "../Common/__styles__/Layout";
import { EmptyState } from "../Common/EmptyState";
import SmallLoading from "../Common/Icons/SmallLoading";
import { IllustrationName } from "../Common/Illustration";
import { Body } from "../Common/Typography";
import { SearchContext } from "./SearchContext";

export const SearchEmptyState = ({
  expandPlaceholders,
  title,
  icon,
  body,
}: {
  expandPlaceholders: boolean;
  title: string;
  icon?: IllustrationName;
  body?: string;
}) => {
  const { showScopeBar } = useContext(SearchContext);

  if (expandPlaceholders && icon && body) {
    return (
      <EmptyState
        icon={icon}
        paddingTop={spacing["2xl"].value}
        title={title}
        body={body}
      />
    );
  }

  const compactPadding =
    showScopeBar ? {} : { paddingTop: 0, paddingBottom: 0 };

  return <EmptyState compact title={title} {...compactPadding} />;
};

export const SearchLoadingState = ({ expand }: { expand: boolean }) => {
  const { showScopeBar } = useContext(SearchContext);

  if (expand) {
    return (
      <FlexColumn
        data-testid="omnibox-results-loading"
        gap="m"
        style={{
          paddingTop: spacing["3xl"].value,
          alignItems: "center",
        }}
      >
        <SmallLoading />
        <Body type="emphasis" size="default" color="contentPlaceholder">
          Loading...
        </Body>
      </FlexColumn>
    );
  }

  const compactLoadingPadding =
    showScopeBar ?
      { paddingTop: 28, paddingBottom: 6 }
    : { paddingTop: spacing.xs.value, paddingBottom: spacing.xs.value };

  return (
    <FlexColumn
      data-testid="omnibox-results-loading"
      style={{ alignItems: "center", ...compactLoadingPadding }}
    >
      <SmallLoading />
    </FlexColumn>
  );
};
